<template>
    <div>
        <load mode="table" v-if="loading" />
        <form v-else @submit.prevent="cadastarPessoaReferencia" ref="addItem">
            <label class="d-block font-weight-bold mb-3">
                Registrar todas as pessoas de referência para a pessoa idosa:
                parentes e amigos mais próximos, mesmo aqueles que não residiam
                com a pessoa idosa. Exceto a composição familiar já listado
                acima.
            </label>
            <div class="row">
                <form-input v-model="nome" label="Nome" :required="true" />
                <form-input
                    v-model="parentesco"
                    label="Parentesco/ posição Familiar"
                    grid="6"
                    :required="true"
                />
                <form-input
                    v-model="idade"
                    label="Idade"
                    grid="6"
                    :required="true"
                />
                <form-input
                    v-model="telefone"
                    label="Telefone"
                    v-mask="'(##) # ####-####'"
                    placeholder="(00) 0 0000-0000"
                    grid="6"
                    :required="true"
                />
                <form-input
                    v-model="email"
                    label="E-mail"
                    grid="6"
                    :required="true"
                />
                <form-input
                    v-model="endereco"
                    label="Endereço"
                    :required="true"
                />
            </div>
            <div class="row col-12 pb-3 px-0 m-0 d-flex justify-content-end">
                <button
                    class="btn btn-primary m-0"
                    data-style="zoom-in"
                    type="submit"
                >
                    Cadastrar
                </button>
            </div>
        </form>
        <div class="row">
            <div class="col-12" v-if="pessoaReferencia.length > 0">
                <table
                    class="table table-sm border table-bordered mb-3"
                    v-for="(pessoa, index) in pessoaReferencia"
                    :key="pessoa.id"
                >
                    <tbody>
                        <tr>
                            <td class="py-0" colspan="2">
                                Nome: <b>{{ pessoa.nome }}</b>
                                <a
                                    title="Excluir"
                                    @click="excluirPessoa(pessoa.id, index)"
                                    class="float-right px-2 mb-0 text-danger "
                                >
                                    <i class="mdi mdi-close"></i>
                                </a>
                            </td>
                        </tr>
                        <tr>
                            <td class="py-0" colspan="2">
                                Parentesco/ posição Familiar:
                                <b>{{ pessoa.parentesco }}</b>
                            </td>
                        </tr>
                        <tr>
                            <td class="py-0">
                                Telefone:
                                <b>{{ pessoa.telefone }}</b>
                            </td>
                            <td class="py-0">
                                E-mail:
                                <b>{{ pessoa.email }}</b>
                            </td>
                        </tr>
                        <tr>
                            <td class="py-0" colspan="2">
                                Endereço:
                                <b>{{ pessoa.endereco }}</b>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-12" v-else>
                <h4 class="text-secondary">
                    <i class="mdi mdi-24px mdi-alert-decagram-outline"></i>
                    Nada salvo aqui.
                </h4>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["item"],
    data() {
        return {
            nome: "",
            parentesco: "",
            idade: "",
            telefone: "",
            email: "",
            endereco: "",
            loading: false,
            tipo_cadastro: "",
            pessoaReferencia: {}
        };
    },
    watch: {
        item() {
            if (this.item.pessoaReferencia != null) {
                this.pessoaReferencia = this.item.pessoaReferencia;
            }
        }
    },
    mounted() {
        if (this.item.pessoaReferencia != null) {
            this.pessoaReferencia = this.item.pessoaReferencia;
        }
    },
    methods: {
        submit() {
            this.item.pessoaReferencia = this.pessoaReferencia;
            this.$emit("submit");
        },
        cadastarPessoaReferencia() {
            this.loading = true;
            let ladda = Ladda.create(document.querySelector(".btn-submit"));
            ladda.start();
            axios
                .post(
                    `api/dashboard/acolhimento/idoso/storepessoa`,
                    {
                        nome: this.nome,
                        parentesco: this.parentesco,
                        idade: this.idade,
                        telefone: this.telefone,
                        email: this.email,
                        endereco: this.endereco,
                        acolhimento_id: this.item.id,
                        tipo_cadastro: "Idoso"
                    },
                    {
                        header: { "Content-Type": "multipart/form-data" },
                        onUploadProgress: event => {
                            let progress = Math.round(
                                (event.loaded * 100) / event.total
                            );
                            this.progressCompleted = progress;
                        }
                    }
                )
                .then(response => {
                    ladda.stop();

                    this.$snack.success({
                        button: false,
                        text: response.data.data.message
                    });
                    this.$emit("reload");
                })
                .finally(() => {
                    this.limpar();
                });
        },
        excluirPessoa(id) {
            swal.fire({
                text: "Aguarde a ação ser finalizada.",
                icon: "warning",
                showConfirmButton: false,
                timer: 1500
            });
            axios
                .get(`api/dashboard/acolhimento/idoso/pessoa/excluir/${id}`)
                .then(response => {
                    this.$snack.success({
                        button: false,
                        text: response.data.data.message
                    });
                    this.$emit("reload");
                });
        },
        verificarValueArray(value, array, valueIsArray = false) {
            if (valueIsArray && value) {
                var a = "";
                for (var i = 0; i < value.length; i++) {
                    const result = array.filter(item => item.id == value[i]);
                    a += result[0].value + (i < value.length - 1 ? "," : "");
                }

                return a;
            } else {
                const result = array.filter(item => item.id == value);
                return result[0] ? result[0].value : "";
            }
        },
        limpar() {
            this.nome = "";
            this.parentesco = "";
            this.idade = "";
            this.telefone = "";
            this.email = "";
            this.endereco = "";
            this.tipo_cadastro = "";
            this.loading = false;
        }
    }
};
</script>
